import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import DoneImage from "../../Components/assets/Images/congratsdoneimage.svg";
import ErrorImage from "../../Components/assets/Images/errorImage.svg";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../../pages/Styles/Redirect.module.scss";
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";

import { FinUpdateAccountAggregatorFetchDataFinupdateAPICall } from "./APICalls";
import { REDIRECTURL } from "../../shared/constants";

export default function FinUpdateFetchIncomeResponse() {
  const [countDown, setCountDown] = useState(3);
  const [displayError, setDisplayError] = useState(false);
  const [loading, setLoading] = useState(false);

  const pathName = useLocation().search;
  const dispatch = useDispatch();

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const doc_id = params.id;
  const req = params.request_id;
  const state = params.state;
  const navigate = useNavigate();
  const userObject: any = state ? jwt_decode(state) : {};
  // console.log("userObject", userObject);

  function sendDetails() {
    let obj: any = {
      // consent_id: doc_id,
      request_id: userObject?.request_id,
      callback_url: "",
    };
    setLoading(true);
    FinUpdateAccountAggregatorFetchDataFinupdateAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("res", responseData)
        setLoading(false);
        const redirectParams = new URLSearchParams(window.location.search);
        redirectParams.set("status", "success");
        navigate({ search: urlParams.toString() }, { replace: true });
        setTimeout(() => {
          window.location.href = `${REDIRECTURL}finupdate/documents_upload?status=success`;
        }, 3000);
      })
      .catch((error: any) => {
        setLoading(false);
        setDisplayError(true);
        const redirectParams = new URLSearchParams(window.location.search);
        redirectParams.set("status", "failed");
        navigate({ search: redirectParams.toString() }, { replace: true });
        setTimeout(() => {
          window.location.href = `${REDIRECTURL}finupdate/documents_upload?status=failed`;
        }, 3000);
      });
  }

  //   useEffect(() => {
  //     sendDetails();
  //   }, []);

  useEffect(() => {
    if (window.location.href.includes("Cancelled")) {
      //  console.log("cancel");
      setDisplayError(true);
    } else {
      setDisplayError(false);
      sendDetails();
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountDown((prevCountDown) => prevCountDown - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (countDown < 0) {
      setCountDown(3);
    }
  }, [countDown]);

  return (
    <>
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            {loading ? (
              <CircularProgress style={{ width: "80px", height: "80px" }} />
            ) : (
              <img src={!displayError ? DoneImage : ErrorImage} />
            )}
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                {" "}
                {loading
                  ? "Inprogress..."
                  : displayError
                    ? "Error fetching your Documents"
                    : "We have obtained your documents"}{" "}
              </p>
              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  {loading
                    ? "Please wait..., we are fetching your Documents. Please don't Close the Window."
                    : `You will be redirect in 3 second.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
